import useClient from "@graphql/client";
import { Provider as UrqlProvider } from "urql";

const UrqlProviderWrapper = ({ children }) => {
    const client = useClient();
    return <UrqlProvider value={client}>{children}</UrqlProvider>;
};

export default UrqlProviderWrapper;
